import { Picker, Toast } from "antd-mobile";
import { PickerColumnItem, PickerValue } from "antd-mobile/es/components/picker";
import { isEqual } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FormatOptionFunc, SelectPickerProps } from "../DynamicForm";
import { cn, createBEM } from "@/libs";
import './index.scss';
import { useNavigate } from "react-router-dom";
const formatOption: FormatOptionFunc = option => ({
  label: option.text,
  value: option.value
});
export const SelectPicker = ({
  options,
  value,
  onChange,
  readOnly,
  noDataFun = () => {}
}: SelectPickerProps) => {
  const navigate = useNavigate();
  const b = createBEM('i-selectpicker');
  const [visible, setVisible] = useState(false);
  const [state, setState] = useState<(string)[]>([]);
  useEffect(() => {
    const nextValue = Array.isArray(value) ? value : [];
    if (!isEqual(state, nextValue)) {
      setState(nextValue);
    }
  }, [value]);
  const onValueChange = useCallback((value: PickerValue[]) => {
    if (!isEqual(state, value)) {
      setState((value as string[]));
      return onChange((value as string[]));
    }
  }, [state]);
  const columns: PickerColumnItem[][] = useMemo(() => {
    if (!options) {
      return [];
    }
    const columns: PickerColumnItem[][] = [];
    for (let i = 0; i < options.length; i++) {
      const items = options[i];
      const columnItems: PickerColumnItem[] = [];
      for (let j = 0; j < items.length; j++) {
        const item = items[j];
        columnItems.push(formatOption(item));
      }
      columns.push(columnItems);
    }
    return columns;
  }, [options]);
  const onShowViewer = useCallback(() => {
    if (readOnly) return '';
    if (columns.length) {
      return setVisible(true);
    } else {
      Toast.show('无可用选项！');
      return noDataFun(navigate);
    }
  }, [readOnly]);
  const text = useMemo(() => {
    const strArr: string[] = [];
    for (let i = 0; i < state.length; i++) {
      const value = state[i];
      const option = options[i].find(option => option.value === value);
      if (option) {
        strArr.push(option?.text);
      }
    }
    return strArr.join('、');
  }, [state, options]);
  return <div className={cn(b())} data-sentry-component="SelectPicker" data-sentry-source-file="index.tsx">
    <div onClick={onShowViewer}>{text || <span className={cn(b('empty'))}>请选择</span>}</div>
    <Picker columns={columns} visible={visible} onClose={() => {
      setVisible(false);
    }} value={value} onConfirm={onValueChange} data-sentry-element="Picker" data-sentry-source-file="index.tsx" />
  </div>;
};